
/* eslint-disable @typescript-eslint/no-inferrable-types */
import { Component } from 'vue-property-decorator';
import WidgetMixins from '../../mixins/WidgetMixins';
import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';
import { email, numeric, max, required } from 'vee-validate/dist/rules';
import { mixins } from 'vue-class-component';
import { namespace } from 'vuex-class';
import AuthLayout, { IPanelRow } from './components/AuthLayout.vue';

extend('email', {
  ...email,
  message: 'Email is not valid',
});
extend('required', {
  ...required,
  message: 'Field is required',
});
extend('numeric', {
  ...numeric,
  message: 'Invalid phone number provided',
});
extend('max', {
  ...max,
  message: 'Phone number cannot be more than 10',
});

const authModule = namespace('auth');

@Component({
  components: {
    ValidationProvider,
    ValidationObserver,
    AuthLayout,
  },
})
export default class RegisterAsDeveloper extends mixins(WidgetMixins) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @authModule.Action('registerAsDeveloper') actionRegister: any;
  name: string = '';
  email: string = '';
  phone: string = '';
  password: string = '';
  acceptPrivacyPolicy: boolean = true;
  confirmPassword: string = '';
  show: boolean = false;

  panelRows: IPanelRow[] = [
    {
      icon: 'sms',
      title: 'Bulk & Personalized SMS',
      text: 'Send to thousands of contacts with delivery reports in real time.',
    },
    {
      icon: 'code',
      title: 'Developer-friendly APIs',
      text: 'Generate API keys and integrate SMS into your own apps.',
    },
    {
      icon: 'support_agent',
      title: '24/7 local support',
      text: 'A team in Ghana that actually picks up.',
    },
  ];

  register(): void {
    if (this.password.trim() !== this.confirmPassword.trim()) {
      this.$store.dispatch('snackBarMessage', "Password doesn't match", {
        root: true,
      });
      this.$store.dispatch('snackBarVisibility', true, { root: true });
      return;
    }
    let payload = {
      name: this.name,
      email: this.email,
      phone: this.phone,
      password: this.password,
      isBusiness: false,
      acceptPrivacyPolicy: this.acceptPrivacyPolicy,
    };
    this.actionRegister(payload);
  }
}
